import icons from '@icons';
import { snowflake } from '@images';
import type { FC } from 'react';
import { memo } from 'react';
import Picture from '../Picture';
import Tooltip from '../Tooltip';
import './index.scss';
const {
  store: { white: storeWhiteFilled },
  rocket: { white: rocketWhiteFilled }
} = icons.Fill;

interface InfoIconProps {
  height: number;
  className?: string;
}

export const FreezeIcon: FC<InfoIconProps> = memo(({ height, className }) => (
  <Tooltip
    repositionOnResize
    on={['hover', 'focus']}
    tooltipText={'Заморозка'}
    offsetY={0}
  >
    <div className={`freeze-icon ${className || ''}`}>
      <Picture icon={snowflake} height={height} width={height} />
    </div>
  </Tooltip>
));

export const ExpressIcon: FC<InfoIconProps> = memo(({ height, className }) => (
  <Tooltip
    repositionOnResize
    on={['hover', 'focus']}
    offsetY={0}
    tooltipText={'Забрать сейчас'}
  >
    <div className={`express-icon ${className || ''}`}>
      <Picture icon={storeWhiteFilled} height={height} width={height} />
    </div>
  </Tooltip>
));

export const DeliveryFastIcon: FC<InfoIconProps> = memo(
  ({ height, className }) => (
    <Tooltip
      repositionOnResize
      offsetY={0}
      on={['hover', 'focus']}
      className='Tooltip--longer'
      tooltipText=''
      componentText={
        <span className='text-center'>
          Товар доступен <br /> для экспресс-доставки
        </span>
      }
    >
      <div className={`deliveryFast-icon ${className || ''}`}>
        <Picture icon={rocketWhiteFilled} height={height} width={height} />
      </div>
    </Tooltip>
  )
);
